import React, { useState } from 'react';

function SurveyStepTwentyTwo({ formData, onNext }) {
    const [contributionRating, setContributionRating] = useState(formData.contributionRating || '');
    const [contributionComments, setContributionComments] = useState(formData.contributionComments || '');
    const [error, setError] = useState('');

    const handleContinue = () => {
        if (!contributionRating) {
            setError('Please select a rating.');
            return;
        }
        setError('');
        onNext({ contributionRating, contributionComments });
    };

    const ratingOptions = ['N/A', ...Array.from({ length: 10 }, (_, i) => (i + 1).toString())];

    return (
        <div className="step-form">
            <h6 className="mb-4">Section 5: Employee Experience</h6>

            {error && <div className="alert alert-danger">{error}</div>}

            <label className="form-label">
                Do you feel your contributions make a difference? <span className="text-danger">*</span>
            </label>

            <div className="d-flex flex-wrap gap-2 mb-4 justify-content-around">
                {ratingOptions.map((option) => (
                    <div key={option} className="form-check rating_btn">
                        <input
                            type="radio"
                            id={`contribution-rating-${option}`}
                            name="contributionRating"
                            value={option}
                            checked={contributionRating === option}
                            onChange={() => setContributionRating(option)}
                        />
                        <label htmlFor={`contribution-rating-${option}`}>{option}</label>
                    </div>
                ))}
            </div>

            <div className="mb-3">
                <label className="form-label">Additional comments (optional):</label>
                <textarea
                    className="form-control"
                    rows="4"
                    value={contributionComments}
                    onChange={(e) => setContributionComments(e.target.value)}
                    placeholder="Share any additional thoughts here..."
                />
            </div>

            <div className="text-end mt-5">
                <button
                    className="btn btn-dark px-4"
                    onClick={handleContinue}
                    disabled={!contributionRating}
                >
                    Next
                </button>
            </div>
        </div>
    );
}

export default SurveyStepTwentyTwo;
